import * as PIXI from 'pixi.js';
import CardContainer from './cardContainer';
import ActionButtonsContainer from './actionButtonsContainer';
import { RESOLUTION, APP_WIDTH, APP_HEIGHT, CARD_WIDTH, CARD_HEIGHT, getProxiedCardImageUrl, redrawFullScreenOverlay } from '../utils/commonUtils';

export default class PlayerTriggerContainer extends PIXI.Container {
    constructor() {
        super();

        const playerTriggerBackground = new PIXI.Graphics();
        playerTriggerBackground.label = 'playerTriggerBackground';
        playerTriggerBackground.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        playerTriggerBackground.fill({ color: '#000000' });
        playerTriggerBackground.alpha = 0.7;
        this.addChild(playerTriggerBackground);

        const playerTriggerCardContainer = new CardContainer();
        playerTriggerCardContainer.label = 'playerTriggerCardContainer';
        playerTriggerCardContainer.x = 0;
        playerTriggerCardContainer.y = 500;
        playerTriggerCardContainer.scale.set(3.6);
        playerTriggerCardContainer.eventMode = 'none';
        this.addChild(playerTriggerCardContainer);

        const title = new PIXI.Text({
            text: 'Trigger Effect?',
            style: {
                fontFamily: 'Arial',
                fontSize: 75,
                fill: '#ffffff',
            }
        });
        title.label = 'title';
        title.anchor.set(0.5, 1);
        title.x = 0;
        title.y = -580;
        this.addChild(title);

        const actionButtonsContainer = new ActionButtonsContainer();
        actionButtonsContainer.label = 'actionButtonsContainer';
        actionButtonsContainer.x = 0;
        actionButtonsContainer.y = 700;
        actionButtonsContainer.update({ clientGameState: { availableActions: ['KEEP_TRIGGER', 'ACTIVATE_TRIGGER'] } });
        this.addChild(actionButtonsContainer);
    }

    setCardInstance(cardInstance) {
        const playerTriggerCardContainer = this.getChildByLabel('playerTriggerCardContainer');
        const actionButtonsContainer = this.getChildByLabel('actionButtonsContainer');
        playerTriggerCardContainer.updateCardInstance(cardInstance);
        playerTriggerCardContainer.hidePowerText();

        if (cardInstance.hasTriggerEffect) {
            const title = this.getChildByLabel('title');
            title.text = 'Trigger Effect?';
            actionButtonsContainer.update({ clientGameState: { availableActions: ['KEEP_TRIGGER', 'ACTIVATE_TRIGGER'] } });
        } else {
            const title = this.getChildByLabel('title');
            title.text = 'No Trigger!';
            actionButtonsContainer.update({ clientGameState: { availableActions: ['KEEP_TRIGGER'] } });
        }
    }

    resize(width, height) {
        redrawFullScreenOverlay(this.getChildByLabel('playerTriggerBackground'), width, height);
    }
}